module.exports = __webpack_public_path__ + "img/first_bg02.babb09f1.png";